import "regenerator-runtime/runtime";

var _marked = /*#__PURE__*/regeneratorRuntime.mark(_callee2);

/*
 * Copyright (c) 2019 Wells Fargo. 45 Fremont Street, San Francisco, CA 94105 All rights reserved.
 *
 *This software is the confidential and proprietary information of Wells Fargo
 *bank. ('Confidential Information'). You shall not disclose such Confidential
 *Information and shall use it only in accordance with the terms of the license
 *agreement you entered into with WellsFargo.
 *
 *Author: Thomas Barry
*/
// Update the browser url to reflect the current view
import { takeLatest, select, put } from 'redux-saga/effects';
import { push, replace } from 'connected-react-router';
import { getViewUrl } from '../../../workflow-utils/workflow-utils';
import { getLocation } from '../../selectors';
import { WORKFLOW_UPDATE_PATH_FOR_VIEW } from '../actions';
export default function _callee2() {
  return regeneratorRuntime.wrap(function _callee2$(_context2) {
    while (1) {
      switch (_context2.prev = _context2.next) {
        case 0:
          _context2.next = 2;
          return takeLatest(WORKFLOW_UPDATE_PATH_FOR_VIEW, /*#__PURE__*/regeneratorRuntime.mark(function _callee(payload) {
            var workflowName, viewName, viewIndex, navigationIndex, pushFirstView, _yield$select, pathname;

            return regeneratorRuntime.wrap(function _callee$(_context) {
              while (1) {
                switch (_context.prev = _context.next) {
                  case 0:
                    workflowName = payload.workflowName, viewName = payload.viewName, viewIndex = payload.viewIndex, navigationIndex = payload.navigationIndex, pushFirstView = payload.pushFirstView;
                    _context.next = 3;
                    return select(getLocation);

                  case 3:
                    _yield$select = _context.sent;
                    pathname = _yield$select.pathname;

                    if (!(navigationIndex === 1 && !pushFirstView)) {
                      _context.next = 10;
                      break;
                    }

                    _context.next = 8;
                    return put(replace(getViewUrl(pathname, workflowName, viewName, viewIndex, navigationIndex)));

                  case 8:
                    _context.next = 12;
                    break;

                  case 10:
                    _context.next = 12;
                    return put(push(getViewUrl(pathname, workflowName, viewName, viewIndex, navigationIndex)));

                  case 12:
                  case "end":
                    return _context.stop();
                }
              }
            }, _callee);
          }));

        case 2:
        case "end":
          return _context2.stop();
      }
    }
  }, _marked);
}